import StackTrace from 'stacktrace-js';

window.addEventListener('error', event => {
  report(event.error);
});

window.addEventListener('unhandledrejection', event => {
  report(event.reason);
});

async function report(error: Error) {
  const trace = await StackTrace.fromError(error);
  StackTrace.report(trace, '/api/error', `${location}: ${error.message}`);
}
